import React from 'react';

const APP_NAME = 'AcademyOS';

export default function AppFooter() {
  return (
    <footer className="pt-4 pb-3 mt-5 border-top text-center text-muted small">
      <div className="container">
        &copy; {new Date().getFullYear()} {APP_NAME}. All rights reserved.
      </div>
    </footer>
  );
}
